import Vue from "vue";
const vm = Vue.prototype;
import $i18n from "../i18n";

import fileTypes from "../service/file-types.js";

export const state = () => ({
  application: [],
});

export const mutations = {
  INIT_APPLICATION(state, payload) {
    state.application = payload;
  },

  SET_APPLICATION(state, payload) {
    state.application = payload;
  },

  SET_APPLICATION_PHOTO(state, payload) {
    const obj = { ...state.application };
    if (payload) {
      const { param, id } = payload;

      obj[param] = `/api/v1/admin/olimpiada2024/file/${id}`;
    }

    state.application = obj;
  },
};

export const actions = {
  async INIT_APPLICATION({ commit }, application) {
    const app = application;
    commit("INIT_APPLICATION", app);
    return;
  },

  SET_APPLICATION({ commit }, payload) {
    commit("SET_APPLICATION", payload);
  },

  async SAVE_APPLICATION({ commit, dispatch }, application) {
    const params = { ...application };
    const url = "admin/olimpiada2024";
    const data = await vm.$axios.$post(url, params);
    const status = data != null;
    if (status) {
      application.status = "SUBMITTED";
      commit("SET_APPLICATION", application);

      dispatch(
        "SET_SNACKBAR",
        {
          text: $i18n.t("Successfully sent!"),
          color: "success",
        },
        { root: true }
      );
    }

    return status;
  },

  async GET_FILE_API(ctx, { url }) {
    if (url) {
      return await vm.$axios.$getImage(url);
    } else return null;
  },

  async DELETE_FILE_API({ commit }, { param, applicationId }) {
    const fileType = fileTypes[param];

    if (fileType) {
      const url = `admin/olimpiada2024/file/${fileType}/${applicationId}`;
      const status = await vm.$axios.$delete(url);

      if (status != null) {
        commit("SET_APPLICATION_PHOTO", { url: null, param });
      }
    }
  },
};

export const getters = {
  GET_APPLICATION: (state) => state.application,
};
